import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Unavailability from './partials/Unavailability';
import TutorProfileLayout from './TutorProfileLayout';

class CustomUnavailability extends Component {

    componentDidMount() {
        localStorage.setItem('activeStep', 3);
    } 

    render() {
        return (<TutorProfileLayout activeClass="TutorProfile">
            <div className="background-page">
                <Unavailability />
                <div className="form-group text-center">
                    <hr />
                    <Link className="btn btn-primary" to="/tutor/set-availability">Back</Link>
                    <hr />
                </div>
                <div className="row">
                    <div className="col-lg-8 col-md-12 col-12 text-center mx-auto">
                        <img src="/images/b-tutor.png" width="100%"/>
                    </div>
                </div>
            </div>
        </TutorProfileLayout>);
    }
}

export default CustomUnavailability;